document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
  const state = CPB.getStore().getState();
  if (!state || !state.Product || !state.Product.base) return;

  const price = state.Product.base.price;
  
  // Where the CPB product title is located
  const titleElement = document.querySelector('.cpb-product-title');
  if (!titleElement) return;

  // ---- PRICE ----
  const priceElement = document.createElement('div');
  priceElement.className = 'cpb-custom-price';
  priceElement.textContent = `$${price}`;

  // Insert price under title
  titleElement.insertAdjacentElement('afterend', priceElement);

  // ---- SUBTEXT ----
  const shippingText = document.createElement('div');
  shippingText.className = 'cpb-custom-subtext';
  shippingText.textContent = 'Shipping calculated at checkout';

  // Insert under price
  priceElement.insertAdjacentElement('afterend', shippingText);
});
